import { render, staticRenderFns } from "./HorizontalSchedule.vue?vue&type=template&id=b180063a"
import script from "./HorizontalSchedule.vue?vue&type=script&lang=js"
export * from "./HorizontalSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports